import { capitalize } from "@exonn/utils";

/**
 * Replace Laravel validation placeholders in a message string.
 *
 * Example:
 * replacePlaceholders(
 *   "The :attribute must be between :min and :max characters.",
 *   { attribute: "Title", min: 3, max: 10 }
 * )
 *
 * → "The Title must be between 3 and 10 characters."
 */
export function replacePlaceholders(message: string, replacements = {}) {
  return Object.entries(replacements).reduce((result, [key, value]) => {
    const strValue = String(value);

    // Regex replaces:
    // :key
    // :Key  (capitalized)
    // :KEY  (uppercase)
    const regex = new RegExp(`:${key}`, "gi");

    return result.replace(regex, (match) => {
      if (match === `:${key}`) return strValue; // exact case
      if (match === `:${capitalize(key)}`) return capitalize(strValue);
      if (match === `:${key.toUpperCase()}`) return strValue.toUpperCase();
      return strValue; // fallback
    });
  }, message);
}
